import { FC, ReactElement } from 'react';
import styles from './mobile-modal.module.scss';
import { WModal } from 'components/wrappers/wrapper';
import { Divider, Slide } from '@mui/material';
import Button from 'components/atoms/button/button';
import CloseIcon from '@mui/icons-material/Close';

interface MobileModalProps {
  title: string;
  open: boolean;
  onClose: () => void;
  className?: string;
  children?: ReactElement;
}
const MobileModal: FC<MobileModalProps> = ({ className, title, open, onClose, children }) => {
  const classes = `${styles.modalContainer} ${className || ''}`.trim();
  return (
    <WModal
      open={open}
      onClose={onClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Slide in={open} direction="up" mountOnEnter unmountOnExit>
        <div className={classes}>
          <div className={styles.header}>
            <span>{title}</span>
            <Button type="base" onClick={onClose}>
              <CloseIcon fontSize="small" />
            </Button>
          </div>
          <Divider />
          <div>{children}</div>
        </div>
      </Slide>
    </WModal>
  );
};

export default MobileModal;
